export default __webpack_public_path__ + "static/media/README.3a50f1ab.md";